import RichTextValue from './RichTextValue';
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import Help from '@mui/icons-material/Help';
import RenderEditField from './RenderField';
import RenderValueField from './RenderValue';

import './styles.scss';

/**
 *
 * @param {{
 * card: import("../../hooks/use-form-data").FieldsData;
 * values: Record<string, string | number | boolean>;
 * orientation: "horizontal" | "vertical";
 * isEdit: boolean;
 * handleBlur: VoidFunction;
 * handleChange: VoidFunction;
 * }} props
 * @returns
 */
const DataView = ({
  card,
  values,
  orientation,
  isEdit,
  handleChange,
  handleBlur,
  historyStates
}) => {
  if (!card) {
    return <div className="category-wrapper"></div>;
  }

  const categoryListClasses = [
    'category-list',
    orientation === 'horizontal' ? 'horizontal' : ''
  ]
    .filter(Boolean)
    .join(' ');

  const renderHint = (text) => (
    <Tooltip title={text}>
      <Help fontSize="small" className="hint-icon" />
    </Tooltip>
  );

  /**
   * @param {import("../../hooks/use-form-data").Field} item
   * @returns
   */
  const renderData = (item) => {
    if (historyStates) {
      const state = historyStates[item.field_id] || 'no_history';
      if (state !== 'available')
        return (
          <span className="value" data-history-state={state}>
            {state === 'incompatible' ? 'Unavailable' : '-'}
          </span>
        );
      if (item.field.field_type === 'checkbox')
        return (
          <span className="value">
            {String(values[item.field_id]) === 'true' ? 'Yes' : 'No'}
          </span>
        );
    }
    if (item.field.field_type === 'richtext' && !isEdit) {
      return (
        <RichTextValue value={values[item.field_id]} label={item.field.label} />
      );
    }
    if (isEdit) {
      return (
        <RenderEditField
          field={item}
          fieldType={item.field.field_type}
          values={values}
          handleBlur={handleBlur}
          handleChange={handleChange}
        />
      );
    }

    return (
      <RenderValueField
        fieldId={item.field_id}
        fieldType={item.field.field_type}
        values={values}
        selectOptions={item.field.config.options}
        config={item.field.config}
      />
    );
  };

  return (
    <div className="category-wrapper">
      {card.description ? (
        <h4 className="category-title">{card.description}</h4>
      ) : null}
      <ul className={categoryListClasses}>
        {card.items.map((field) => (
          <li
            key={field.field_id}
            className={
              field.field.field_type === 'richtext'
                ? 'category-list-item category-list-item--richtext'
                : 'category-list-item'
            }
          >
            {field.field.field_type !== 'richtext' && renderData(field)}
            <span className="title">
              <span>{field.field.label}</span>
              {field.field.description
                ? renderHint(field.field.description)
                : null}
            </span>
            {field.field.field_type === 'richtext' && renderData(field)}
          </li>
        ))}
      </ul>
    </div>
  );
};

DataView.propTypes = {
  card: PropTypes.any,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  isEdit: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.any,
  historyStates: PropTypes.object
};

DataView.defaultTypes = {
  card: {},
  orientation: 'horizontal',
  isEdit: false,
  values: {},
  handleChange: () => {},
  handleBlur: () => {}
};

export default DataView;
